import React from 'react';
import ReactDOM from 'react-dom';
import dialogLoader from '../../utilities/dialogLoader';
import { CcusConnectingDialog } from '../modals/CcusConnectingDialog';
import PartnerCompanyCcusService from '../../services/PartnerCompanyCcus';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import {
  JOINING_FLAG,
  STATUS_CODE,
  TIME_OUT_TWO_SECOND,
} from '../../utilities/constants';
import { setWaitTime } from '../../utilities/commonUtil';
import { FormInformationDialog } from '../FormInformationDialog';
import { messageUtility } from '../../utilities/messageUtility';
import Information from '../modals/common/Information';
import styles from '../../styles/componentStyle/workerForm/workerForm.scss';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { isPartnerCompanyRoleId } from '../../utilities/roleUtility';
import _ from 'lodash';

/**
 * CCUS連携フォーム
 */
export class CompanySyncDataCcusButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ccus_connecting_dialog: false,
      visibleDialogInfo: false,
      roleId: LocalStorageService.getRoleId(),
      joining_flag: SessionStorageService.getPartnerCompanyJoiningFlag(),
    };
    this.fetchCcusCompanyFlag = false; // 多重取得防止Flag
    this.informationModal = {
      title: null,
      message:
        'CCUSから事業者情報を取得しました。\nBuildeeのデータに反映するには、各項目の編集画面から転記を行ってください。',
      buttonText: messageUtility.getMessage('I-000-011'),
    };
  }

  /**
   * 通信エラーダイアログを表示
   */
  showCcusNetworkerrorDialog = message => {
    return new Promise(resolved => {
      dialogLoader.show(FormInformationDialog, {
        title: 'CCUS連携エラー',
        message,
        tabFocus: true,
        onClose: () => {
          dialogLoader.close();
          resolved(true);
        },
      });
    });
  };

  getCcusConnectInfo = event => {
    // ボタンからフォーカスを外す
    event.target.blur();
    const companyId = this.props.selected_partner_company_id;
    const apiParams = {
      company_id: companyId,
      ccus_jigyousya_id: this.props.ccusid,
    };
    let ccus_connecting_dialog = true;
    this.setState({ ccus_connecting_dialog }, () => {
      // 多重登録防止
      if (this.fetchCcusCompanyFlag) {
        return;
      }
      this.fetchCcusCompanyFlag = true;

      PartnerCompanyCcusService.beginFetchCcusCompanyData(apiParams)
        .then(response => {
          if (response.result) {
            this.monitoringFetchCcusCompanyData(
              response.data.entities.ccus_state_management_id,
              companyId
            );
          } else {
            this.showCcusNetworkerrorDialog(response.data.message);
            ccus_connecting_dialog = false;
            this.fetchCcusCompanyFlag = false;
          }
        })
        .catch(error => {
          this.showCcusNetworkerrorDialog(error.message);
          ccus_connecting_dialog = false;
          this.fetchCcusCompanyFlag = false;
        })
        .finally(() => {
          this.setState({ ccus_connecting_dialog });
        });
    });
  };

  /**
   * CCUS事業者情報取得状況を監視する
   * @param {number} ccusStateManagementId CCUSステータス管理ID
   * @param {string} companyId 会社ID
   * */
  monitoringFetchCcusCompanyData = (ccusStateManagementId, companyId) => {
    setWaitTime(TIME_OUT_TWO_SECOND).then(() => {
      const params = {
        ccus_state_management_id: ccusStateManagementId,
        company_id: companyId,
      };
      let { ccus_connecting_dialog, visibleDialogInfo } = this.state;
      PartnerCompanyCcusService.fetchCcusCompanyData(params)
        .then(response => {
          if (response.result) {
            if (response.status === STATUS_CODE.ok) {
              // ステータスコードが正常(200)の場合
              ccus_connecting_dialog = false;
              visibleDialogInfo = true;
              this.fetchCcusCompanyFlag = false;
            } else if (response.status === STATUS_CODE.accepted) {
              // ステータスコードが処理中(202)の場合
              // 再度現場情報取得状況を監視する
              this.monitoringFetchCcusCompanyData(
                ccusStateManagementId,
                companyId
              );
            } else {
              this.showCcusNetworkerrorDialog(response.message);
              ccus_connecting_dialog = false;
              this.fetchCcusCompanyFlag = false;
            }
          } else {
            const message = _.get(
              response,
              'message',
              _.get(response, 'data.message', '')
            );
            this.showCcusNetworkerrorDialog(message);
            ccus_connecting_dialog = false;
            this.fetchCcusCompanyFlag = false;
          }
        })
        .catch(error => {
          this.showCcusNetworkerrorDialog(error.message);
          ccus_connecting_dialog = false;
          this.fetchCcusCompanyFlag = false;
        })
        .finally(() => {
          this.setState({ ccus_connecting_dialog, visibleDialogInfo }, () => {
            if (
              _.has(this.props, 'callback') &&
              !_.isUndefined(this.props.callback)
            ) {
              this.props.callback();
            }
          });
        });
    });
  };

  /**
   * CCUS連携通信中ダイアログ
   */
  showCcusConnectingDialog = () => {
    return this.state.ccus_connecting_dialog ? (
      <BackgroundLayer
        modalRoot='root'
        modalState={this.state.ccus_connecting_dialog}
      >
        <CcusConnectingDialog />
      </BackgroundLayer>
    ) : null;
  };

  ccusButton = () => {
    return (
      isPartnerCompanyRoleId(this.state.roleId) &&
      this.state.joining_flag === JOINING_FLAG.commonPartnerCompany.id && (
        <button
          className={this.props.inDescription ? 'btn' : 'btn--effective'}
          onClick={this.getCcusConnectInfo}
          disabled={this.fetchCcusCompanyFlag}
        >
          CCUSから情報を取得
        </button>
      )
    );
  };

  closeDialog = () => {
    this.setState({ visibleDialogInfo: false });
  };

  render() {
    return (
      <React.Fragment>
        {this.ccusButton()}
        {this.showCcusConnectingDialog()}
        <Information
          rootClassName={styles.fetchCompleteDialog}
          visible={this.state.visibleDialogInfo}
          title={this.informationModal.title}
          message={this.informationModal.message}
          buttonText={this.informationModal.buttonText}
          onClose={this.closeDialog}
          tabFocus
        />
      </React.Fragment>
    );
  }
}

/***
 * popupの背景
 */
const BackgroundLayer = ({ modalRoot, children }) => {
  const _modalRoot = document.getElementById(modalRoot);
  return ReactDOM.createPortal(children, _modalRoot);
};



// WEBPACK FOOTER //
// ./src/components/button/CompanyFetchDataCcusButton.jsx